// Translation: Two-factor authentication > Landing > Form (Russian)
export default Object.freeze({
	form: {
		actions: {
			activate: '',
			reload: '',
			skip: ''
		},
		fallback: {
			message: ''
		},
		fields: {
			code: {
				placeholder: ''
			}
		},
		title: ''
	}
})
